import Store_BuildingBlocks from "@bd-components/store-building-blocks";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import Store_Sequences from "@bd-components/store-sequences";
import Store_Storage from "@bd-components/store-storage";
import Store_Variable from "@bd-components/store-variable";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import $ from "jquery";
import fb from "@bd-core/firebase";
import Timer from "@bd-utils/timer";
import { getState, store } from "@bd-stores/store";
import {
  setFinished,
  setFinishedAt,
  setShouldFinishAt,
  setStartedAt,
  // setIsGameScreenPopup,
  // getIsGameScreenPopup,
  // setIsGameTimeout,
} from "@bd-stores/game-progress";
import { updatePlayerPageId, updateAttributes } from "./firebase-actions";

class GameLogic {
  constructor() {
    // this.currentBlockType = false;
    // this.currentBlockID = 0;
    this.transisitonDuration = 275;
  }

  async init() {
    this.timer = new Timer(() => this.onTimeOut());

    // only call initialize function on homepage / main game
    if ($("body").hasClass("homepage") || $("body").hasClass("home")) {
      // load storage
      const storage = new Store_Storage(CONFIG.GP); // see store-storage.js
      storage.load();
      Store_Sequences.init();

      window.bdStorage = storage;

      this.registerGlobalListeners();
      this.registerGlobalEvents();

      // Initialize Firebase before rendering blocks so setup answers are in Redux
      //-----------------------------------------------------------------------
      try {
        await fb.initializeGame();
      } catch (e) {
        console.error(e);
      }
      //-----------------------------------------------------------------------

      this._initialize();
    }
  }

  pauseTimer() {
    this.timer.pauseTimer();
  }

  continueTimer() {
    this.timer.continueTimer();
  }

  registerGlobalListeners() {
    const applyTeamTimerAttributes = (attributes = {}) => {
      const timerConfig = CONFIG.game_options.timer_config;
      const startedAt = attributes.startedAt || null;

      if (startedAt) {
        store.dispatch(setStartedAt(startedAt));

        if (
          timerConfig.is_enable_timer &&
          timerConfig.timer_mode === "count_up"
        ) {
          this.timer.start();
        }
      }

      const shouldFinishAt = attributes.shouldFinishAt || null;

      if (shouldFinishAt) {
        store.dispatch(setShouldFinishAt(shouldFinishAt));

        if (
          timerConfig.is_enable_timer &&
          timerConfig.timer_mode === "count_down"
        ) {
          this.timer.start();
        }
      }

      // const isTimeout = attributes.isTimeout || false;
      // if (isTimeout) {
      //   store.dispatch(setIsGameTimeout(true));
      //   setTimeout(() => {
      //     this._initialize();
      //   }, 1000);
      // }

      const finishedAt = attributes.finishedAt || null;
      if (finishedAt) {
        store.dispatch(setFinishedAt(finishedAt));
      }

      const isFinished = attributes.isFinished || false;
      if (!isFinished) return;

      store.dispatch(setFinished(true));
      this.timer.stopTimer();

      bdjs.showLoading();

      setTimeout(() => {
        setTimeout(() => this.onFinish(), this.transisitonDuration);
      }, this.transisitonDuration);
    };

    bdjs.listen("bd__teamAttributeChanged", (e, eventData) => {
      applyTeamTimerAttributes(eventData?.data || {});
    });

    bdjs.listen("bd__teamInitialState", (e, eventData) => {
      applyTeamTimerAttributes(eventData?.data?.attributes || {});
    });
  }

  registerGlobalEvents() {
    const $pageWrapper = $("#pageWrapper");

    $pageWrapper.on("click", ".js-back", () => {
      this.goBack();
    });

    $pageWrapper.on("click", ".js-continue", () => {
      this.goToDefaultNextBlock();
    });
  }

  _initialize() {
    /* Prepare building block data */
    const data = CONFIG.user_progress;
    const building_blocks = CONFIG.building_blocks;

    try {
      Store_BuildingBlocks.set(building_blocks);
      // Store_Variable.set(data.answer_variables);
      Store_SequenceHistory.set(data.history);

      this.currentBlockID = data.current_block_id ?? 0;
      this.currentBlockType = data.current_block_type ?? false;

      this.jumpToBlock();
      this._render();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("Error : Failed to fetch game data! " + error);
    }
  } //-- END _initialize()

  _render() {
    const blockData = this._getBlockData(this.currentBlockID);
    const blockParamID = this.getUrlParameter("blockID");
    const currentBlock = bdjs.getBlock(blockData.data.type);

    if (currentBlock?.type === "end" && blockParamID) return;

    if (currentBlock) {
      currentBlock._setData(blockData.data);
      currentBlock.init();
      //Hide loading screen
      if (!currentBlock._serverSide) {
        bdjs.hideLoading();
      }
    } else {
      console.error(
        "Component : Can't find component " + this.currentBlockType,
      );
    }
  } //-- END _render()

  _getBlockData(blockID, blockType) {
    let _data = {};
    let _type = null;

    if (typeof Store_BuildingBlocks.data[blockID] !== "undefined") {
      const theBlockData = Store_BuildingBlocks.data[blockID];
      _data = theBlockData;
      _type = theBlockData.type;
    }

    if (blockID === 0 || blockType === "end") {
      _data = { type: "end" };
      _type = "end";
    }

    _data = Store_Variable.resolveBlock(_data);

    return {
      type: _type,
      data: _data,
    };
  } //-- EMD _getBlcokData()

  getCurrentBlockID() {
    return "" + this.currentBlockID;
  }

  getCurrentBlockType() {
    return this.currentBlockType;
  }

  goBack(blockID) {
    // const block = Store_BuildingBlocks.data[blockID];
    const skipHistory = true;
    this.goTo(blockID, skipHistory);
  }

  goTo(blockID, skipHistory = false) {
    const block = Store_BuildingBlocks.data[blockID] || { type: "end" };
    const destinationBlockData = this._getBlockData(blockID, block.type);

    // End is not a real building block — it lives on /end-page/. Inline render
    // would require #end-template, which is never output on the homepage.
    if (blockID == 0 || destinationBlockData.type === "end") {
      bdjs.showLoading(() => {
        this.maybeReadyToFinish();
      });
      return;
    }

    const destinationBlock = bdjs.getBlock(destinationBlockData.type);

    var history = {
      prev: this.getCurrentBlockID(),
      next: Number.parseInt(blockID),
    };

    if (!skipHistory) {
      Store_SequenceHistory.data[history.next] = history;
    }

    if (destinationBlock) {
      bdjs.showLoading(() => {
        const _prevBlock = bdjs.getBlock(this.currentBlockType);
        if (_prevBlock) _prevBlock.destroy();

        destinationBlock._setData(destinationBlockData.data);
        destinationBlock.init();

        this.currentBlockID = blockID;
        this.currentBlockType = destinationBlockData.type;
        updatePlayerPageId(this.currentBlockID);

        //Hide loading screen
        if (!destinationBlock._serverSide) {
          bdjs.hideLoading();
        }
      });
    } else {
      console.error(
        "Component : Can't find block type " + destinationBlockData.type,
      );
    }
  }

  goToDefaultNextBlock() {
    const blockID = this.getCurrentBlockID();
    const answer = {
      current_block: blockID,
      answer_data: -1,
    };
    const storyMode = CONFIG.game_options.story_mode;
    const nextSeqId = Store_Sequences.getNext(answer) || 0;
    const isLikeResult = Store_Sequences.isLikeResult(nextSeqId);

    bdjs.showLoading(() => {
      const submitToServer = (goToNext = true) => {
        bdapi
          .post("game/go-next-sequence", {
            current_block_id: blockID,
          })
          .then((res) => {
            const resData = res.data;
            const data = resData.data;

            if (!data) return alert("failed to submit, please reload the page");

            if (goToNext) {
              BD_GAME_LOGIC.goTo(data.next_sequence);
            }

            return false;
          })
          .catch(() => {
            alert("Error : Failed to fetch data from server!");
          });
      };

      if (storyMode && !isLikeResult) {
        submitToServer(false);
        BD_GAME_LOGIC.goTo(nextSeqId);
      } else {
        submitToServer(true);
      }
    });
  }

  jumpToBlock() {
    const userRole = CONFIG.user?.userRole;
    const blockParamID = this.getUrlParameter("blockID");

    if (!blockParamID) return false;

    if ($.inArray("administrator", userRole) == -1)
      return window.location.replace(CONFIG.currentURL);

    setTimeout(() => {
      this.goTo(blockParamID);
    }, 300);
  }

  getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  onFinish() {
    bdjs.showLoading();

    setTimeout(() => {
      window.location.href = CONFIG.siteURL + "/end-page/";
    }, this.transisitonDuration);
  }

  async onTimeOut() {
    bdjs.showLoading();

    const shouldFinishAt = getState().gameProgress.shouldFinishAt;

    await bdjs.goAsync(
      bdapi.post("game/timeout", { should_finish_at: shouldFinishAt }),
    );
  }

  async maybeReadyToFinish() {
    updateAttributes({
      isFinished: true,
      finishedAt: Date.now(),
    });
  }
}

const BD_GAME_LOGIC = new GameLogic();
export default BD_GAME_LOGIC;
